import { TLocalization } from '@/types/TLocalization';
import * as yup from 'yup';
// Passwords must:
// - contain at least 1 uppercase letter,
// - contain at least 1 lowercase letter,
// - contain at least 1 number or special character,
// - be at least 8 characters long.
const passwordRegex: RegExp =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9!@#$%^&*()-_=+[\]{}|;:'",.<>?/\\]).{8,}$/;

export const getPasswordValidation = (t: TLocalization) => {
  return yup
    .string()
    .required(t('forms.passwordEmpty'))
    .min(8, t('setNewPassword.newPasswordInvalid'))
    .matches(passwordRegex, t('setNewPassword.newPasswordInvalid'));
};
